// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_AtualizarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * PlanoMetas Atualizar Response Contract
 *
 * Response for POST /plano_metas/atualizar/:id - Update a goal plan
 *
 * @package Contracts
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlanoMetas_AtualizarResponseDados {
id: number
franquia_id: number
data_inicial: string
data_final: string
status: string
created_at: string
updated_at: string
meta_faturamento?: number
meta_clientes?: number
numero_dias_uteis?: number
ticket_medio_esperado?: number
observacao?: string
created_by?: number
deleted_at?: string
periodo_formatado?: string
}

export type PlanoMetas_AtualizarResponse = ApiResponse<PlanoMetas_AtualizarResponseDados>;

registerResponseContract('PlanoMetas_AtualizarResponse', {
  id:                    { type: 'number',  required: true },
  franquia_id:           { type: 'number',  required: true },
  data_inicial:          { type: 'string',  required: true },
  data_final:            { type: 'string',  required: true },
  status:                { type: 'string',  required: true },
  created_at:            { type: 'string',  required: true },
  updated_at:            { type: 'string',  required: true },
  meta_faturamento:      { type: 'number',  required: false },
  meta_clientes:         { type: 'number',  required: false },
  numero_dias_uteis:     { type: 'number',  required: false },
  ticket_medio_esperado: { type: 'number',  required: false },
  observacao:            { type: 'string',  required: false },
  created_by:            { type: 'number',  required: false },
  deleted_at:            { type: 'string',  required: false },
  periodo_formatado:     { type: 'string',  required: false },
})
